<template>
  <div class="baseFormRender">
    <!-- 是否有render -->
    <RenderDom v-if="$attrs.render" :props="$attrs" :render="$attrs.render" />
    <!-- text -->
    <div v-else-if="$attrs.renderType === 'text'" :style="styles">
      {{ currentValue }}
    </div>
    <el-button v-else-if="$attrs.renderType === 'button'" :style="styles" v-bind="$attrs" v-on="$listeners">
      {{ $attrs.label }}
    </el-button>
    <!-- 没有render -->
    <!-- inputNumber 类型 -->
    <el-input-number v-else-if="$attrs.renderType === 'inputNumber'" :style="contentStyles" v-bind="$attrs" :value="currentValue" v-on="$listeners" @input="onInput" />
    <!-- input 类型 -->
    <el-input v-else-if="$attrs.renderType === 'input'" :placeholder="currentPlaceholder" :style="styles" v-bind="$attrs" :clearable="currentClearable" :value="currentValue" v-on="$listeners" @input="(value)=>onInput(value.trim())" />
    <el-input v-else-if="$attrs.renderType === 'inputTrim'" :placeholder="currentPlaceholder" :style="styles" v-bind="$attrs" :clearable="currentClearable" :value="currentValue" v-on="$listeners" @input="onInput" />
    <!-- input-textarea 类型 -->
    <el-input v-else-if="$attrs.renderType === 'textarea'" :placeholder="currentPlaceholder" :style="styles" type="textarea" v-bind="$attrs" :clearable="currentClearable" :value="currentValue" v-on="$listeners" @input="onInput" />
    <!-- autocomplete 类型 -->
    <el-autocomplete v-else-if="$attrs.renderType === 'autocomplete'" :placeholder="currentPlaceholder" v-bind="$attrs" value-key="value" :clearable="currentClearable" :value="currentValue" v-on="$listeners" @input="onInput" />
    <!-- select 类型  -->
    <el-select v-else-if="$attrs.renderType === 'select'" :placeholder="currentPlaceholder" v-bind="$attrs" :style="styles" :clearable="currentClearable" :value="currentValue" v-on="$listeners" @input="onInput">
      <el-option v-for="option in currentOptions" :key="option.optionValue" v-bind="option" :value="option.optionValue" :label="option.optionLabel" />
    </el-select>
    <!-- radio 类型 -->
    <el-radio-group v-else-if="$attrs.renderType === 'radioGroup'" :size="$attrs.size || 'medium'" v-bind="$attrs" :value="currentValue" v-on="$listeners" @input="onInput">
      <template v-if="$attrs.isButton">
        <el-radio-button v-for="(option, index) in currentOptions" v-bind="option" :key="isDef(option.optionValue) ? option.optionValue : index" :border="$attrs.isBorder || false" :label="option.optionValue">
          <RenderDom v-if="option.renderLabel" :render="option.renderLabel" :props="option" />
          <span v-else>{{ option.optionLabel }}</span>
        </el-radio-button>
      </template>
      <template v-else>
        <el-radio v-for="(option, index) in currentOptions" v-bind="option" :key="isDef(option.optionValue) ? option.optionValue : index" :border="$attrs.isBorder || false" :label="option.optionValue">
          <RenderDom v-if="option.renderLabel" :render="option.renderLabel" :props="option" />
          <span v-else>{{ option.optionLabel }}</span>
        </el-radio>
      </template>
    </el-radio-group>
    <!-- checkbox group -->
    <el-checkbox-group v-else-if="$attrs.renderType === 'checkboxGroup'" :size="$attrs.size || 'medium'" v-bind="$attrs" :value="currentValue" v-on="$listeners" @input="onInput">
      <template v-if="$attrs.isButton">
        <el-checkbox-button v-for="(option, index) in currentOptions" :key="index" v-bind="option" :label="option.optionValue">
          {{ option.optionLabel }}
        </el-checkbox-button>
      </template>
      <template v-else>
        <el-checkbox v-for="(option, index) in currentOptions" :key="index" v-bind="option" :label="option.optionValue">
          {{ option.optionLabel }}
        </el-checkbox>
      </template>
    </el-checkbox-group>
    <el-checkbox v-else-if="$attrs.renderType === 'checkbox'" v-bind="$attrs" :value="currentValue" v-on="$listeners" @input="onInput">
      {{ $attrs.content }}
    </el-checkbox>
    <!-- cascader -->
    <el-cascader v-else-if="$attrs.renderType === 'cascader'" :placeholder="currentPlaceholder" v-bind="$attrs" :style="styles" :value="currentValue" v-on="$listeners" @input="onInput" />
    <!-- switch -->
    <el-switch
      v-else-if="$attrs.renderType === 'switch'"
      is-range
      range-separator="至"
      start-placeholder="开始时间"
      end-placeholder="结束时间" placeholder="选择时间范围" v-bind="$attrs" :value="currentValue" v-on="$listeners" @input="onInput"
    />
    <!-- 时分秒 -->
    <el-time-picker v-else-if="$attrs.renderType === 'timePicker'" v-bind="$attrs" :value="currentValue" v-on="$listeners" @input="onInput" />
    <!-- 时分 -->
    <el-time-select v-else-if="$attrs.renderType === 'timeSelect'" v-bind="$attrs" :value="currentValue" @input="onInput" v-on="$listeners" />
    <!-- image -->
    <el-image v-else-if="$attrs.renderType === 'image'" v-bind="$attrs" v-on="$listeners" />


    
    <!-- 时间范围 -->
    <BaseDatePickerRange v-else-if="$attrs.renderType === 'datePickerRange'" :style="styles" v-bind="$attrs" :value="currentValue" v-on="$listeners" @input="onInput" />
    <BaseDateTimeRange v-else-if="$attrs.renderType === 'dateTimeRange'" :style="styles" v-bind="$attrs" :value="currentValue" v-on="$listeners" @input="onInput" />
    <!-- 时间搜索 单个 -->
    <el-date-picker v-else-if="$attrs.renderType === 'datePicker'" v-bind="$attrs" v-model="baseForm.model[$attrs.valueKey]" type="date" :style="styles" v-on="$listeners" />
    <!-- 周选择器 -->
    <el-date-picker v-else-if="$attrs.renderType === 'weekPicker'" v-bind="$attrs" v-model="baseForm.model[$attrs.valueKey]" type="week" :style="styles" v-on="$listeners" />
    <!-- 月维度选择 -->
    <el-date-picker v-else-if="$attrs.renderType === 'monthPicker'" v-bind="$attrs" v-model="baseForm.model[$attrs.valueKey]" type="month" :style="styles" v-on="$listeners" />
    
  </div>
</template>
<script>
/**
 * @desc 基础组件 form 表单 render
 * @param {String} renderType input  输入框   √
 * @param {String} renderType select 选择框 √
 * @param {String} renderType switch 开关
 * @param {String} renderType checkbox 多选
 * @param {String} renderType radioGroup  ridio 单选
 * @param {String} renderType checkboxButton  按钮多选
 * @param {String} renderType departTree 部门 √
 * @param {string} renderType datePickerRange 时间区间选择器 带有快捷项
 *
 */
import RenderDom from '@/utils/renderDom'
// 数据渠道树
// import DataChannelTreePermission from '@/views/userCenter/childviews/newRoleChannelTree'
import { getPropByPath } from 'element-ui/src/utils/util'
import BaseDatePickerRange from './BaseDatePickerRange.vue'
import BaseDateTimeRange from './BaseDateTimeRange.vue'

import { isDef } from '@/utils/utils'

export default {
  name: 'BaseFormRender',
  components: {
    RenderDom,
    BaseDatePickerRange,
    BaseDateTimeRange
  },
  inject: ['baseForm'],
  inheritAttrs: false,
  props: {
    renderData: {
      type: Object,
      default: () => {}
    },
    styles: {
      type: [Object, String],
      default: () => {}
    },
    contentStyles:{
       type: [Object, String],
      default: () => {} 
    }
  },
  computed: {
    // 经过转换后的options
    currentOptions () {
      const { optionLabel = 'label', optionValue = 'value' } = this.$attrs
      try {
        const options = this.$attrs.options.map(option => {
          return {
            ...option,
            optionValue: option[optionValue] !== undefined ? option[optionValue] : '', // 字符串的情况下
            optionLabel: optionLabel instanceof Array ? this.$attrs.optionLabel.map(item => option[item]).join('-') : option[optionLabel] // 如果是数组的情况下

          }
        })
        return options
      } catch (e) {
        return []
      }
    },
    // 经过转换后的value
    currentValue () {
      if (this.$attrs.value !== undefined) return this.$attrs.value
      // 判断是否有嵌套场景 TODO
      // 剔除空值
      if (!this.$attrs.valueKey) return ''
      // 如果是多个子级
      const prop = getPropByPath(this.baseForm.model, this.$attrs.valueKey, true)
      return prop.o[prop.k]
    },
    // 选项clearable属性的传值修改
    currentClearable () {
      if (this.$attrs.clearable !== undefined) return this.$attrs.clearable
      return true
    },
        // 自动生成的placeholder
    currentPlaceholder(){
      if (this.$attrs.placeholder || this.$attrs.render) return this.$attrs.placeholder
      const inputPlaceholder = ['input','textarea','autocomplete','cascader']
      const selectPlaceholder = ['select','selectV2','selectGroup']
      if (inputPlaceholder.includes(this.$attrs.renderType) )  {
        return `请输入${this.renderData.label}`
      }else  if (selectPlaceholder.includes(this.$attrs.renderType) )  {
        return `请选择${this.renderData.label}`
      }else{
        return ''
      }
    }
  },
  created(){
    // console.log({this.styles, this.contentStyles},'styles')
  },
  methods: {
    /**
     * @description v-model 的语法糖
     */
    onInput (value) {
      // 首先判断有key
      const valueKey = this.$attrs.valueKey
      if (!valueKey) return
      // 判断是否需要字符串方式赋值
      // TODO 待完善
      if (valueKey.includes('.')) {
        const prop = getPropByPath(this.baseForm.model, this.$attrs.valueKey, true)
        prop.o[prop.k] = value
      } else {
        this.baseForm.model[valueKey] = value
      }
    },
    isDef
  }

}
</script>

<style lang="scss" scoped>
.baseFormRender {
  .el-select__tags-text {
    max-width: 70px!important;
  }
  .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
}
</style>
